import React from "react";
import styles from "./styles.module.scss";

export const ButtonMobileMenu = ({ onClick }) => (
  <button onClick={onClick} className={styles.root}>
    <span />
    <span />
    <span />
  </button>
);
